import { FC } from 'react'
import { observer } from 'mobx-react'
import { useStores } from '@/utils'
import { GlobalLoadingIndicator } from '@components/organisms/GlobalLoadingIndicator'

export const SessionPageTemplate: FC = observer(({ children }) => {
  const { viewer } = useStores()
  if (viewer.isInitialized) {
    return <div>{children}</div>
  }
  return <GlobalLoadingIndicator />
})
